import { render, staticRenderFns } from "./SemicircleDiagram.vue?vue&type=template&id=7960f7e6&scoped=true&"
import script from "./SemicircleDiagram.vue?vue&type=script&lang=js&"
export * from "./SemicircleDiagram.vue?vue&type=script&lang=js&"
import style0 from "./SemicircleDiagram.vue?vue&type=style&index=0&id=7960f7e6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7960f7e6",
  null
  
)

export default component.exports